import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as React from 'react';
import classNames from 'classnames';
import Conditional from '../misc/Conditional/index.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var Button = function Button(_a) {
  var _b = _a,
    _b$size = _b.size,
    size = _b$size === void 0 ? "medium" : _b$size,
    _b$type = _b.type,
    type = _b$type === void 0 ? "primary" : _b$type,
    _b$iconRight = _b.iconRight,
    iconRight = _b$iconRight === void 0 ? false : _b$iconRight,
    _b$children = _b.children,
    children = _b$children === void 0 ? "Button component" : _b$children,
    _b$Icon = _b.Icon,
    Icon = _b$Icon === void 0 ? "" : _b$Icon,
    _b$loading = _b.loading,
    loading = _b$loading === void 0 ? false : _b$loading,
    _b$disabled = _b.disabled,
    disabled = _b$disabled === void 0 ? false : _b$disabled,
    _b$color = _b.color,
    color = _b$color === void 0 ? "default" : _b$color,
    expand = _b.expand,
    onClick = _b.onClick,
    _b$onlyIcon = _b.onlyIcon,
    onlyIcon = _b$onlyIcon === void 0 ? false : _b$onlyIcon,
    _b$spaceBetween = _b.spaceBetween,
    spaceBetween = _b$spaceBetween === void 0 ? false : _b$spaceBetween,
    _b$htmlType = _b.htmlType,
    htmlType = _b$htmlType === void 0 ? "button" : _b$htmlType,
    justify = _b.justify,
    props = __objRest(_b, ["size", "type", "iconRight", "children", "Icon", "loading", "disabled", "color", "expand", "onClick", "onlyIcon", "spaceBetween", "htmlType", "justify"]);
  var buttonClasses = classNames("iq-btn", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "iq-btn--type-".concat(type), !!type), "iq-btn--size-".concat(size), !!size), "iq-btn--expand-".concat(expand), !!expand), "iq-btn--color-".concat(color), !!color && color !== "default"), "iq-btn--justify-".concat(justify), !!justify), "iq-btn--disabled", !!disabled), "iq-btn--loading", !!loading), "iq-btn--icn-right", !!iconRight && !onlyIcon), "iq-btn--only-icon", !!onlyIcon), "iq-btn--space-between", !!spaceBetween && !loading));
  function handleClick(e) {
    if (!disabled && !!onClick) onClick(e);
  }
  return /* @__PURE__ */React.createElement("button", __spreadValues({
    className: buttonClasses,
    type: htmlType,
    onClick: handleClick,
    disabled: loading ? true : disabled
  }, props), /* @__PURE__ */React.createElement(Conditional, {
    condition: !!Icon,
    renderIf: /* @__PURE__ */React.createElement("div", {
      className: "iq-btn__icon-slot"
    }, /* @__PURE__ */React.createElement(Icon, null))
  }), /* @__PURE__ */React.createElement(Conditional, {
    condition: !onlyIcon,
    renderIf: /* @__PURE__ */React.createElement("span", {
      className: "iq-btn__text"
    }, children)
  }), /* @__PURE__ */React.createElement(Conditional, {
    condition: loading,
    renderIf: /* @__PURE__ */React.createElement("div", {
      className: "iq-btn__loading-overlay"
    }, /* @__PURE__ */React.createElement("div", {
      className: "iq-btn__loading-spinner"
    }))
  }));
};
export { Button as default };